//
import SlDetailGroupedOffer from '@/models/Sale/SlDetailGroupedOffer'
import SlOfferHeaders from '@/views/Sale/SlOffer/SlOfferHeaders'
import WhProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import WhProductService from '@/services/api/warehouse/WhProduct'

//
export default (props) => [
  {
    name: 'g_branch_office_name',
    type: 'text-field',
    props: {
      label: 'Sucursal',
      readonly: true,
    },
  },
  {
    name: 'name',
    type: 'text-field',
    props: {
      label: 'Nombre',
    },
  },
  {
    name: 'init_datetime',
    type: 'date-field',
    props: {
      pickerProps: {
        //max: '2020-02-20',
      },
      label: 'Inicio',
    },
    trigger: init_datetime_trigger,
  },
  {
    name: 'finish_datetime',
    type: 'date-field',
    props: {
      label: 'Termino',
    },
    trigger: finish_datetime_trigger,
  },
  {
    name: 'sl_offers',
    flex: {
      xs12: true,
    },
    type: 'table-field',
    props: {
      headers: SlOfferHeaders,
      pickerProps: {
        headers: WhProductHeaders,
        mapper: props.sl_selected_grouped_offer_mapper,
        parser: row => new SlDetailGroupedOffer({
          wh_product: row,
          wh_product_id: row.id,
          id: row.id,
          discount: 0,
          discount_percentage: 0,
          offer_price: row.salePriceItem,
          sale_price: row.salePriceItem,
        }),
        rowsPerPage: 15,
        service: WhProductService.toListWithSalePrice(),
      },
      showRemove: true,
      showPicker: true,
      toolbarTitle: 'Listado de ofertas incluidas',
    },
    slots: {
      items: 'sl-selected-grouped-offer-items',
    },
  },
]

/**
 * Set the max date in init_datetime field
 * @param {Object} ctx - the form context
 */
function finish_datetime_trigger(ctx) {
  ctx.getField('init_datetime').props.pickerProps = {
    max: ctx.getValue('finish_datetime'),
  }
}

/**
 * Set the max date in finish_datetime field
 * @param {Object} ctx - the form context
 */
function init_datetime_trigger(ctx) {
  ctx.getField('finish_datetime').props.pickerProps = {
    min: ctx.getValue('init_datetime'),
  }
}